module.exports = __webpack_public_path__ + "static/media/no-trash-no-recycle.9860468a.svg";